<template>
  <div>
    <div v-if="!loading && !entryNotFound">
      <div class="centered-column">
        <div class="container-header">
          <h3>{{ member.name }}</h3>
          <datepicker-component
              @onDateSelected="onDateSelected"
          />
        </div>

        <timesheet-overview-component v-if="timeEntry" :overview="overview"/>

        <div class="d-flex">
          <div class="col col-md-6 pl-0 pr-2">
            <timesheet-payroll-component :payroll="payroll" />
          </div>
          <div class="col col-md-6 pr-0 pl-2" v-if="timeEntry">
            <timesheet-job-codes-component :job-codes="jobCodes" />
          </div>
          <div class="col col-md-6 pr-0 pl-2" v-if="timeOffEntry">
            <time-off-entry-component
                :entry="timeOffEntry"
                :member="member"
            />
          </div>
        </div>
      </div>
      <div class="centered-column">
        <time-entry-component
            v-if="timeEntry"
            :entry="timeEntry"
            :member="member"
            :show-map="true"
        />
    </div>
    </div>
    <div v-if="!loading && entryNotFound">
      <time-entry-not-found-component />
    </div>
  </div>
</template>

<script>

import DatepickerComponent from "./DatepickerComponent";
import ManualEntryComponent from '../shared/ManualEntryComponent';
import TimeEntryComponent from '../shared/components/TimeEntryComponent';
import TimeOffEntryComponent from '../shared/components/TimeOffEntryComponent';
import TimesheetOverviewComponent from "../shared/components/TimesheetOverviewComponent";
import TimesheetPayrollComponent from "../shared/components/TimesheetPayrollComponent";
import TimesheetJobCodesComponent from "../shared/components/TimesheetJobCodesComponent";
import TimesheetService from "../shared/TimesheetService";
import TimeEntryNotFoundComponent from "../shared/components/TimeEntryNotFoundComponent";

export default {
  name: "TimeEntryDetailComponent",
  components: {
    TimeEntryNotFoundComponent,
    DatepickerComponent,
    ManualEntryComponent,
    TimeEntryComponent,
    TimeOffEntryComponent,
    TimesheetOverviewComponent,
    TimesheetPayrollComponent,
    TimesheetJobCodesComponent
  },
  data() {
    return {
      loading: true,
      member: this.getMember(),
      canManageEntry: false,
      date: null,
      jobCodes: [],
      overview: [],
      payroll: null,
      timeEntry: null,
      timeOffEntry: null,
      entryNotFound: false,
      prevFrom: this.$store.state.period.from,
      prevTo: this.$store.state.period.to,
    };
  },
  created() {
    this.getTimeEntry();
  },
  mounted() {
    this.$root.$on('reloadData', this.getTimeEntry);
    this.$root.$on('onEntryDeleted', this.onEntryDeleted);
  },
  beforeDestroy() {
    this.$root.$off('reloadData');
    this.$root.$off('onEntryDeleted');
    this.$store.commit("period", {
      from: this.prevFrom,
      to: this.prevTo,
      fromFormatted: this.$moment(this.prevFrom).format('MMM D, YYYY'),
      toFormatted: this.$moment(this.prevTo).format('MMM D, YYYY')
    });
  },
  methods: {
    getMember() {
      let _this = this;
      if(this.$store.state.showArchivedMembers){
        const members = this.$store.state.archivedMembers.filter(item => {
          return item.uid === _this.$route.params.uid;
        });
        if (members.length > 0) {
          return members[0];
        }
      }

      const members = this.$store.state.members.filter(item => {
        return item.uid === _this.$route.params.uid;
      });
      if (members.length > 0) {
        return members[0];
      }
      return this.$store.state.members[0];
    },
    getTimeEntry() {
        this.loading = true;
        this.$store.commit('showLoading');
        TimesheetService.getTimesheetById(this.$route.params.id).then((result) => {
          console.log(result);
          this.canManageEntry = result.can_manage_entry;
          this.date = result.date;
          this.jobCodes = result.job_codes;
          this.overview = result.overview;
          this.payroll = result.payroll;
          this.timeEntry = result.time_entry;
          this.timeOffEntry = result.time_off_entry;
          this.loading = false;

          const periodDate = this.$moment(this.date);

          this.$store.commit("period", {
            from: periodDate.format('YYYY-MM-DD'),
            to: periodDate.format('YYYY-MM-DD'),
            fromFormatted: periodDate.format('MMM D, YYYY'),
            toFormatted: periodDate.format('MMM D, YYYY')
          });

          this.$store.commit('hideLoading');
        }).catch((error) => {
          console.log(error);
          if(error.response.status === 404) {
            this.entryNotFound = true;
          }
          this.loading = false;
          this.$store.commit('hideLoading');
        })
    },
    onDateSelected: function (dateRange) {
      this.$store.commit('overlay', false);
      this.$store.commit("period", {
        from: this.$moment(dateRange.startDate).format('YYYY-MM-DD'),
        to: this.$moment(dateRange.endDate).format('YYYY-MM-DD'),
        fromFormatted: this.$moment(dateRange.startDate).format('MMM D, YYYY'),
        toFormatted: this.$moment(dateRange.endDate).format('MMM D, YYYY')
      });
      this.$router.push({name: 'MemberTimesheets', params: {uid: this.member.uid}});
    },
    onEntryDeleted() {
      this.$router.push({name: 'MemberTimesheets', params: {uid: this.member.uid}});
    }
  }
}
</script>

<style lang="scss" scoped>
   .container-body {
      padding-left: 5px;
      padding-right: 5px;
    }

  .white-card {
    height: auto;
  }
</style>